const sendToWS = (dispatch, event, data) => {
  dispatch({ type: 'NEW_MESSAGE', event, data });
};

export default sendToWS;
